import { useLockBodyScroll } from '@/hooks';
import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { useSearchParams } from 'react-router-dom';

const RulesModal = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const showRules = searchParams.get('tab') === 'rules';
  useLockBodyScroll(showRules);
  if (!showRules) return null;

  return (
    <div className="fixed inset-0 z-[6000] flex items-center justify-center bg-black/70">
      <div className="w-full max-w-3xl max-h-[80vh] bg-[#0f1117] rounded-xl overflow-hidden shadow-xl">
        {/* Header */}
        <div className="bg-yellow-400 flex items-center justify-between px-5 py-4">
          <h2 className="text-black text-xl font-bold">Rules</h2>
          <button
            onClick={() =>
              setSearchParams((prev) => {
                prev.delete('tab');
                return prev;
              })
            }
          >
            <FaTimes className="text-black text-lg" />
          </button>
        </div>

        {/* Body */}
        <div className="p-5 text-gray-300 text-sm overflow-y-auto scrollbar-hide max-h-[75vh] space-y-4 leading-relaxed">
          {/* GENERAL RULES */}
          <div className="space-y-2">
            <p>1] If you not accept this agreement do not place any bet.</p>
            <p>2] Cheating bets deleted automatically or manual. No Claim.</p>
            <p>3] Admin decision is final and no claim on it.</p>

            <p>
              4] <strong>Batsman Runs (In-Play)</strong> Over/Under (back/lay) runs bets will stand
              after batsman has faced one ball or is given out before first ball is faced. Score
              counts if batsman is Not-Out including if innings is declared. In case of rain, match
              abandoned etc. settled bets will be valid.
            </p>

            <p>
              5] <strong>Runs at Fall of 1st Wicket</strong> At least one delivery must be bowled,
              if no wickets fall bets will be void unless settlement is already determined.
            </p>

            <p>
              6] <strong>Runs at Fall of Next Wicket</strong> The total innings runs scored by a
              team before the fall of the specified wicket determines the result of the market. If a
              team declares or reaches their target then the total amassed will be the result. Bets
              void if play stops before completion.
            </p>

            <p>7] We do not accept manual bet.</p>
            <p>
              8] In case of cheating or unfair rates bets may be cancelled even after settlement.
            </p>
            <p>9] Local fancy are based on Haar - Jeet.</p>
            <p>10] Incomplete session cancelled, complete session settled.</p>
            <p>11] Match abandoned → completed sessions settled.</p>
            <p>12] Tie match → match odds cancelled, session valid.</p>

            <p>
              13] <strong>Lambi Paari</strong>: T20 must complete 20 overs, ODI must complete 50
              overs, otherwise bets cancelled.
            </p>

            <p>14] Advance Session, Lambi 1st Inning Valid Only</p>

            <p>
              15] Total match markets (Runs, Fours, Sixes, Wides, Wickets) → if overs reduce, bets
              cancelled.
            </p>

            <p>
              16] 1st Over Total Runs includes extras. Over must complete unless already settled.
            </p>

            <p>
              17] Limited Overs batsman/partnership markets settled at midpoint if overs reduced.
            </p>

            <p>
              18] Test matches batsman/partnership bets void if 50 overs not bowled (with
              conditions).
            </p>

            <p>19] Technical issues → platform not responsible for loss.</p>
          </div>

          {/* DIVIDER */}
          <div className="border-t border-gray-700" />

          {/* SPECIFIC SPORTS */}
          <div className="space-y-6">
            <h3 className="text-white text-lg font-bold">Specific sports rules</h3>

            {/* CRICKET */}
            <div>
              <h4 className="font-semibold text-white">7. Cricket</h4>

              <p className="mt-2 font-semibold">7.1 General</p>
              <p>If a ball is not bowled → all bets void except determined markets.</p>
              <p>Weather shortened → official result applies (Duckworth Lewis included).</p>
              <p>Bowl-off or toss-decided → bets void except determined markets.</p>

              <p className="mt-2 font-semibold">7.2 Test matches</p>
              <p>
                If match abandoned (non-weather reasons), platform may void bets except determined
                ones.
              </p>
              <p>If not completed within 5 days → all bets void except determined markets.</p>

              <p className="mt-2 font-semibold">7.3 Limited Over matches</p>
              <p>No Result → bets void except determined or minimum overs markets.</p>
              <p>
                New toss (reserve day) → bets placed after 30 mins before original start are void.
              </p>
            </div>

            {/* SOCCER */}
            <div>
              <h4 className="font-semibold text-white">20. Soccer (Football)</h4>

              <p>Material event timing issues → bets may be void.</p>
              <p>VAR cancelled events → bets void between event & cancellation.</p>
              <p>VAR awarded events → counted from review start.</p>

              <p>Postponed match → bets void unless played same day.</p>
              <p>Rescheduled within 72 hrs → bets stand.</p>
              <p>Abandoned match → bets void unless completed same day.</p>

              <p>Venue change → valid unless switched home/away.</p>

              <p>Friendly → must complete full duration.</p>

              <p>Incorrect team details → bets void.</p>

              <p>Relegation bets → based on final standings or penalties.</p>

              <p>Shirt number bets include own goals (default 12 if none).</p>

              <p>First goal timing uses fixed intervals.</p>

              <p>Top scorer excludes own goals.</p>

              <p>Corners counted when taken, not awarded.</p>

              <p>Stats markets settled via independent sources; updates allowed within 48 hours.</p>
            </div>

            {/* TENNIS */}
            <div>
              <h4 className="font-semibold text-white">22. Tennis</h4>

              <p>
                Retirement/disqualification → opponent wins unless less than 1 set completed (then
                void).
              </p>

              <p>
                Tournament event markets void if competition shortened/cancelled unless determined.
              </p>

              <p>Venue/surface changes do not affect bets.</p>

              <p>Match format change → bets void except determined markets.</p>

              <p>Exception: Davis Cup / dead rubber shortened matches remain valid.</p>

              <p>Game/set markets void if interruption occurs before completion.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RulesModal;
